<template>
  <div class="af-page">
    <img src="/img/brand/inexlink.png" alt="InexLink" class="af-logo" />

    <div v-if="estado === 'abriendo'" class="af-box">
      <div class="af-spinner"></div>
      <p class="af-text">{{ $t('fp_abriendo_nueva_ventana') }}</p>
    </div>

    <div v-else class="af-box">
      <p class="af-text">
        {{ estado === 'abierto' ? $t('fp_abierto_nueva_ventana') : $t('fp_popup_bloqueado') }}
      </p>
      <a :href="destino" target="_blank" rel="noopener" class="af-btn">
        {{ $t('fp_ver_detalle_completo') }}
      </a>
    </div>
  </div>
</template>

<script>
/**
 * Página puente entre el PDF de la ficha y la ficha pública.
 *
 * El estándar PDF no permite indicar target="_blank" en los enlaces, así que el visor
 * navega la pestaña donde está el PDF. Esta vista recibe ese clic, abre la ficha pública
 * en una pestaña nueva y retrocede para dejar el PDF donde estaba. Si el navegador bloquea
 * la ventana emergente se muestra un botón para abrirla manualmente (ese clic sí lleva
 * gesto de usuario, por lo que nunca se bloquea).
 */
export default {
  name: 'AbrirFichaPublica',
  data() {
    return {
      estado: 'abriendo', // 'abriendo' | 'abierto' | 'bloqueado'
      destino: '',
    };
  },
  mounted() {
    const idFicha = this.$route.params.idFicha;
    const lang = this.$getLanguage();
    this.destino = `${window.location.origin}/ficha-publica/${encodeURIComponent(idFicha)}?lang=${lang}`;

    let ventana = null;
    try {
      ventana = window.open(this.destino, '_blank');
    } catch (e) {
      ventana = null;
    }

    if (!ventana) {
      this.estado = 'bloqueado';
      return;
    }

    // Corta la referencia al opener por seguridad (equivalente a rel="noopener").
    try { ventana.opener = null; } catch (e) { /* cross-origin: se ignora */ }
    ventana.focus();
    this.estado = 'abierto';

    // Devuelve la pestaña al PDF desde donde vino el clic.
    if (window.history.length > 1) {
      setTimeout(() => { window.history.back(); }, 400);
    }
  },
};
</script>

<style scoped>
.af-page {
  min-height: 100vh;
  background: #f8fafc;
  font-family: 'Inter', 'Segoe UI', sans-serif;
  color: #1e293b;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 28px;
  padding: 32px 20px;
  text-align: center;
}
.af-logo { height: 40px; object-fit: contain; }
.af-box {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 18px;
}
.af-text { margin: 0; color: #475569; font-size: .95rem; }
.af-spinner {
  width: 40px; height: 40px;
  border: 4px solid #e2e8f0;
  border-top-color: #00b8d4;
  border-radius: 50%;
  animation: af-spin .8s linear infinite;
}
@keyframes af-spin { to { transform: rotate(360deg); } }
.af-btn {
  display: inline-block;
  background: #00b8d4;
  color: #fff;
  font-size: .9rem;
  font-weight: 700;
  padding: 10px 22px;
  border-radius: 24px;
  text-decoration: none;
}
.af-btn:hover { background: #0097b2; color: #fff; text-decoration: none; }
</style>
